export const TOGGLE_FEATURE_PREFIX = "TOGGLE_FEATURE_";
export default { TOGGLE_FEATURE_PREFIX };
